import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const enhanceInputSetFocusHOCGenerator = (Component, { inputDOMSelector }) => {
  function EnhanceInputSetFocusHOC(props) {
    const { createdRef, dropdownDisplayed } = props;

    useEffect(() => {
      const focus = () => {
        const domRef = createdRef.current;
        const input = domRef && domRef.querySelector(inputDOMSelector);
        if (input) {
          input.focus();
        }
      };

      if (!dropdownDisplayed) {
        focus();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropdownDisplayed]);

    return <Component {...props} />;
  }

  EnhanceInputSetFocusHOC.propTypes = {
    createdRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    dropdownDisplayed: PropTypes.bool,
  };

  return EnhanceInputSetFocusHOC;
};

const enhanceInputSetFocus =
  ({ inputDOMSelector }) =>
  (Component) =>
    enhanceInputSetFocusHOCGenerator(Component, { inputDOMSelector });

export default enhanceInputSetFocus;
